export default __webpack_public_path__ + "static/media/plus21.970ca3a6.jpg";